<template>
  <v-app :class="`app-root ${getForAccessibility ? 'for-accessibility-app' : ''}`">
    <div class="lang-select">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            dense
            class="table-action mx-1"
            v-bind="attrs"
            v-on="on"
            @click="getHelp(getHelpByLang)"
          >
            mdi-help-circle-outline
          </v-icon>
        </template>
        <div style="white-space: nowrap;" class="tooltip-text">{{ $t('Naudotojo vadovas') }}</div>
      </v-tooltip>
      <a
        @click="changeLang('lt')"
        :class="`lang-select-component ${langLt ? 'lang-select-active' : ''}`"
        style="padding-right: 0.3rem"
        >LT</a
      >
      <a
        @click="changeLang('en')"
        :class="`lang-select-component ${langLt ? '' : 'lang-select-active'}`"
        >EN</a
      >
       <a
        @click="changeForAccessibility()"
        :class="`pl-2`"
        ><v-icon :color="getForAccessibility ? 'primary' : 'secondary'">mdi-glasses</v-icon></a
      >
    </div>
    <v-main class="pt-10">
      <div>
        <img
          class="top-logo"
          :src="computeRCIcon"
          width="70%"
          alt="RC"
          @click="gotoHome()"
        />
      </div>
      <div style="padding-bottom: 4rem" class="page-wrapper mx-12">
        <el-system-info />
        <router-view />
      </div>
      <app-footer></app-footer>
    </v-main>
    <app-fab />
  </v-app>
</template>

<script>
import AppFab from './ireg/AppFab'
import AppFooter from './ireg/AppFooter'
import math from '../mixins/math'
import { mapGetters } from 'vuex'

export default {
  name: 'LayoutPublic',
  components: {
    AppFab,
    AppFooter,
  },
  data() {
    return {}
  },
  mixins: [math],
  computed: {
    ...mapGetters(['getForAccessibility']),
    getHelpByLang(){
      return this.$i18n.locale === 'lt' ? 'manual_public_lt' : 'manual_public_en' 
    },
    langLt() {
      return this.$i18n.locale === 'lt'
    },
    computeRCIcon() {
      return '/static/rclogo.png'
    },
  },

  created() {
    this.$store.dispatch('loadNotifications')
    this.$axios
      .get(`system-notifications/application/public-search`)
      .then((res) => {
        this.$store.dispatch('systemNotification', res.data)
      })
    this.$store.dispatch('loadTooltips')
    if(this.getForAccessibility){
      document.documentElement.style.setProperty('--scrollbar-color', 'gray');
      document.documentElement.style.setProperty('--scrollbar-hover-color', 'gray');
    }
  },
  methods: {
    changeForAccessibility(){
      location.reload()
      this.$store.dispatch('changeForAccessibility', !this.getForAccessibility)
    },
    changeLang(lang) {
      location.reload()
      this.$store.dispatch('changeLanguage', {
        lang: lang,
        i18n: this.$i18n,
        public: true,
      })
    },
    getHelp(name) {
      let formData = { type: name }
      this.$axios
        .post(`download-manual`, formData)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>

<style lang="scss" scoped>
.app-root {
  background: #f5f5f5;
}
.page-wrapper {
  min-height: calc(100vh - 200px);
}
.top-logo {
  width: 18rem;
  padding-left: 3rem;
  margin-bottom: 3rem;
}
.app-drawer {
  overflow: hidden !important;
  &__inner {
    overflow-y: hidden;
  }
  .drawer-menu--scroll {
    overflow: auto;
  }
}
.lang-select {
  text-align: end;
  padding-right: 3rem;
  padding-top: 1rem;
}
.lang-select-component {
  color: #5b8b869e;
}
.lang-select-active {
  color: #198677;
  font-weight: bold;
}
</style>
